'use strict';

var React = require('react');

var SvgLocationNoneIcon = function SvgLocationNoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.227c0-2.331 1.65-3.977 4-3.977.969 0 1.818.28 2.482.771l.987-.986a.762.762 0 0 1 .09-.077c-.941-.764-2.17-1.208-3.559-1.208-3.172 0-5.5 2.31-5.5 5.477 0 1.36.433 2.632 1.032 3.745l1.115-1.116c-.394-.832-.647-1.722-.647-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m7.426 12.2-1.456 1.455a.75.75 0 0 0 1.06 1.061l.259-.258a17.59 17.59 0 0 0 2.035 1.964 10.9 10.9 0 0 0 .208.165l.013.01.004.002.001.001s.001.001.45-.6l-.449.601a.75.75 0 0 0 .898 0l-.449-.601.449.601.002-.002.004-.003.013-.01a4.83 4.83 0 0 0 .208-.164 17.427 17.427 0 0 0 2.273-2.242c1.225-1.458 2.551-3.573 2.551-5.953 0-.612-.087-1.193-.25-1.73l.34-.34a.75.75 0 0 0-1.022-1.097.833.833 0 0 1-.002-.003.805.805 0 0 1-.037.039m-.55 2.672-5.627 5.627a16.033 16.033 0 0 0 1.648 1.638 15.92 15.92 0 0 0 1.8-1.817c1.151-1.371 2.2-3.143 2.2-4.99a4.75 4.75 0 0 0-.022-.458Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.53 5.096-7.104 7.103Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.76 6.118c.153.049.3.112.438.187l-3.393 3.393a2.486 2.486 0 0 1-.305-1.198 2.5 2.5 0 0 1 3.26-2.382Z"
  }));
};
SvgLocationNoneIcon.displayName = "LocationNoneIcon";

exports.SvgLocationNoneIcon = SvgLocationNoneIcon;
